// extracted by mini-css-extract-plugin
export default {"collapse":"CollapsePanel_collapse__y9j7v"};